import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAttributesService {

  constructor(
    private apiBasic: ApiBasicService,
    private api: ApiService,
  ) { }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName: string): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'attribute');
  }


  /**
   * 
   * @param params 
   * @returns 
   */
   getAttributList(params: any): Observable<Res> {

    return this.apiBasic.getAttributList(params, 'attribute');
  }


  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('attribute', id);
  }


  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('attribute', params);
  }


  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  createAccessToAttribute(params: any): Observable<Res> {

    return this.apiBasic.create('attributes_to_roles', params);
  }


  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('attribute', params);
  }


  /**
   * 
   * @param params 
   * @returns 
   */
  attributeUpdate(params: any): Observable<Res> {

    return this.apiBasic.update('attribute_value', params);
  }


  /**
   * 
   * @param params 
   * @returns 
   */
  attributeMandatory(params: any): Observable<Res> {

    return this.apiBasic.attributeMandatory(params);
  }


  /**
   * 
   * @param params 
   * @returns 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('attribute', params);
  }


  /**
   * 
   * @param params 
   * @returns 
   */
  deleteAttribute(params: any): Observable<Res> {

    return this.apiBasic.deleteAttribute(params);
  }


  /**
   * 
   * @param params 
   * @returns 
   */
  deleteAccessToAttributes(params: any): Observable<Res> {

    return this.apiBasic.delete('attributes_to_roles', params);
  }

}
